import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

function Footer() {
    return (
        <footer className="bg-dark text-white py-3">
            <div className="container">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <div className="d-flex gap-3 mb-2 mb-md-0">
                        <a href="https://www.facebook.com/secouristescroixblanche42" className="text-white text-decoration-none">
                            <FontAwesomeIcon icon={faFacebook} size="lg" />
                        </a>
                    </div>
                    <div className="d-flex gap-3 mb-2 mb-md-0">
                        <Link to="/mentions-legales" className="text-white text-decoration-none">
                            Mentions légales
                        </Link>
                        <Link to="/donnees-personnelles" className="text-white text-decoration-none">
                            Données personnelles
                        </Link>
                    </div>
                    <div>
                        <p className="mb-0 text-center text-md-start">
                            &copy; 2025 SFCB de la Loire - Tous droits réservés.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
